{
    "Api tokens": {
        "add token": "新增權杖",
        "description": "用於產生 TCT 與 Configurator 下載 OEM 檔案所需的 API 權杖，或供應用程式請求 FOTA WEB 服務時使用的 API 權杖。API 文件可參閱 <1>此處</1>。",
        "example": "例如：fota_token",
        "generate token": "產生權杖",
        "generated token": "已產生的權杖",
        "last used at": "最後使用時間",
        "name": "權杖名稱",
        "never": "從未",
        "no tokens": "無可用權杖",
        "no tokens description": "權杖新增後將會列於下方",
        "show token list": "顯示權杖清單",
        "titles": {
            "Integration": {
                "description": "用於在您的系統中整合 FOTA WEB 服務",
                "name": "API 整合權杖"
            },
            "Tct": {
                "description": "用於 TCT 與 Configurator 的 OEM 檔案下載",
                "name": "TCT 權杖"
            }
        },
        "tokens": "API權杖",
        "token type": "權杖類型",
        "token was created": "權杖已成功建立"
    },
    "Attributes": {
        "Completed": "已完成",
        "Count": "數量",
        "Current": "目前",
        "Date": "日期",
        "Empty": "空值",
        "excluded files": "排除檔案 (同版本)",
        "Failed": "失敗",
        "Feature": "功能特性",
        "file size bytes": "檔案總大小",
        "File_type": "檔案類型",
        "File_version": "檔案版本",
        "Fingerprint_id": "指紋id",
        "Firmware_date": "韌體日期",
        "Firmware_version": "修訂版本",
        "included files": "包含檔案",
        "Message": "訊息",
        "Metadata": "",
        "newest": "由新到舊",
        "oldest": "由舊到新",
        "Order": "訂單",
        "Password_source": "",
        "Pending": "待處理",
        "Period": "週期",
        "Process_id": "",
        "Protocol_id": "協定id",
        "specific": "特定",
        "Start": "開始",
        "SystemGenerated": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE韌體",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN 韌體",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP 韌體"
        },
        "UserEntered": "",
        "vehicle": "車輛",
        "Vehicle_id": "車輛 id",
        "Vin": "車牌號碼"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "檢查您的驗證器應用程式",
            "check email": "請檢查您的電子郵件",
            "code required": "需驗證碼。",
            "code sent to email": "程式碼已發送至您的電子郵件",
            "code valid": "此代碼僅在數分鐘內有效。",
            "enter code below": "請輸入下方驗證碼登入。",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "需驗證碼。請檢查您的驗證器應用程式，並於下方輸入驗證碼以登入。",
        "check email": "請檢查您的收件匣，並點擊收到的連結以重設密碼。",
        "community forum": "群眾支援論壇",
        "contact us": "聯絡我們",
        "create initial password": "建立密碼",
        "create password": "建立一個密碼",
        "did not receive": "未收到連結？",
        "do not have account": "尚未擁有帳戶？",
        "email": "電子郵件",
        "enter email": "請於下方輸入您註冊的電子郵件，以接收密碼重設指示。",
        "forgot password": "忘記密碼？",
        "forgot your password": "忘記密碼？",
        "for ms365": "適用於 Teltonika MS365 使用者",
        "invalid email format": "電子郵件格式無效",
        "invalid password format": "密碼格式無效",
        "link sent": "連結已發送！",
        "length": "至少 8 個字元",
        "lowercase": "至少包含 1 個小寫字母",
        "new password": "新密碼",
        "password": "密碼",
        "passwords do not match": "密碼不符",
        "privacy policy": "使用 FOTA WEB 即表示您同意我們的 <1>隱私權政策</1>。",
        "remember password": "您記得您的密碼嗎？",
        "repeat password": "重複輸入密碼",
        "required": "需求",
        "resend": "重新發送",
        "reset password": "重設密碼",
        "send reset link": "發送重設連結",
        "sign in": "登入",
        "sign in to fota": "登入您的 FOTA WEB 帳戶",
        "signup": "立即註冊",
        "sso": "使用 Microsoft 帳戶登入",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "大寫字母",
        "user consent text": "我已瞭解並同意 Teltonika 的 <1>服務條款</1> 與 <2>資料處理協定 (DPA)</2>。",
        "welcome": "歡迎使用",
        "wiki": "Telematics Wiki 知識庫"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "接受",
        "accept all": "接受所有",
        "accept selected": "接受所選項目",
        "actions": "操作",
        "add": "新增",
        "add device": "新增裝置",
        "add more files": "新增更多檔案",
        "add new": "新增項目",
        "agree": "我同意",
        "all companies": "所有公司",
        "all of company": "{{companyName}} 全體",
        "all rows selected": {
            "devices": "已選取所有 {{count}} 台裝置",
            "tasks": "所有 {{count}} 個待處理/執行中的任務均已選取",
            "groups": "已選取所有 {{count}} 個群組",
            "files": "已選取所有 {{count}} 個檔案",
            "companies": "已選取所有 {{count}} 家企業",
            "users": "所有 {{count}} 名使用者皆已選取"
        },
        "approve": "核准",
        "assign": "指派",
        "assigning": "指派",
        "auto sync": "",
        "back": "返回",
        "back to sign in": "返回登入頁面",
        "cancel": "取消",
        "cancelling": "取消",
        "cancel all tasks in group": "取消群組內所有任務",
        "cancel tasks": "取消任務",
        "cannot create desktop licenses": "無法為內部公司建立授權。",
        "cannot create offline licenses": "無法為無限制授權建立離線授權。",
        "change": "變更",
        "clear all": "清除所有",
        "clear all filters": "清除所有篩選條件",
        "close": "關閉",
        "company settings": "公司設定",
        "confirm": "確認",
        "continue": "繼續",
        "copied": "複製",
        "copy all": "",
        "copy to clipboard": "複製到剪貼簿",
        "create": "建立",
        "create role": "建立角色",
        "create task": "建立任務",
        "creating": "建立",
        "default view": "預設檢視",
        "delete": "刪除",
        "deleting": "刪除",
        "deselect all": "取消全選",
        "device": "裝置",
        "disable": "停用",
        "disagree": "我不同意",
        "discard": "捨棄",
        "download": "",
        "edit": "編輯",
        "enable": "啟用",
        "export": "匯出",
        "exporting": "匯出",
        "filters": "過濾器",
        "finish": "",
        "find tool": "尋找工具",
        "first page": "首頁",
        "fmx and legacy": "FMx 與舊版系統",
        "ft platform": "FT平台",
        "generate": "生成",
        "generate codes": "",
        "go back": "返回",
        "import": "匯入",
        "importing": "匯入",
        "invite": "邀請",
        "invite user": "邀請使用者",
        "invite user to internal disabled": "僅管理員經理及更高權限層級可邀請使用者加入內部公司。",
        "language": "語言",
        "last page": "上一頁",
        "logout": "登出",
        "maximize details": "最大化細節",
        "merge": "合併",
        "merging": "合併",
        "minimize details": "最小化細節",
        "more actions": "更多操作",
        "more filters": "更多篩選條件",
        "more options": "更多選項",
        "move": "移動",
        "moving": "移動",
        "next": "Next",
        "next month": "下個月",
        "next page": "下一頁",
        "no actions available": "無可用操作",
        "no permission": "您需要「{{permissionName}}」權限。",
        "no permissions": "您需要以下權限：{{permissionNames}}。",
        "notify when done": "完成時通知我",
        "number of selected companies": "{{companyCount}} 家 {{companyName}} 企業",
        "only essential": "僅保留必要功能",
        "open fota web": "開放式 FOTA WEB",
        "pages of": "共 {{total}} 項",
        "previous month": "上個月",
        "previous page": "上一頁",
        "print": "",
        "receive devices": "接收裝置",
        "refresh page": "刷新",
        "reject all": "拒絕所有",
        "reset to default": "重置為預設值",
        "retry failed tasks": "重新嘗試失敗任務",
        "retrying": "重新嘗試",
        "return home": "我們回家吧",
        "revert manual level change": "還原手動層級變更",
        "rows count per page": "每頁顯示的行數",
        "rows selected": "{{count}} 已選取",
        "save": "儲存",
        "saving": "",
        "see all": "查看全部",
        "select all": {
            "devices": "選取所有 {{count}} 台裝置",
            "tasks": "選取所有 {{count}} 個待處理/執行中任務",
            "groups": "全選 {{count}} 個群組",
            "files": "全選 {{count}} 個檔案",
            "companies": "選取所有 {{count}} 家公司",
            "users": "選取所有 {{count}} 位使用者"
        },
        "select columns to show": "選擇要顯示的欄位",
        "selected page is first": "所選頁面為首頁",
        "selected page is last": "所選頁面為最後一頁",
        "select rows": "選取資料列",
        "send code": "傳送程式碼",
        "settings": "設定",
        "show me": "請展示給我",
        "show more": "顯示更多",
        "synchronize": "同步",
        "table statistics": "表格統計",
        "table view": "表格檢視",
        "transfer": "傳輸",
        "transferring": "傳輸",
        "transfer my devices": "轉移我的裝置",
        "undo": "撤銷",
        "upload": "上傳",
        "upload file": "上傳新檔案",
        "user": "使用者",
        "verify": "驗證",
        "yes": "是"
    },
    "Cookies": {
        "always active": "持續運作",
        "analytics cookies": "分析型Cookie",
        "analytics cookies description": "這些追蹤器用於分析，協助收集數據以了解使用者與我們網站的互動方式。這些洞察使我們既能優化內容，也能開發更優質的功能來提升使用者體驗。此類Cookie可被停用。",
        "cookie banner message": "我們與精選第三方會基於技術目的使用Cookie或類似技術，並在您同意的情況下，用於《隱私權政策》中所述的其他用途。",
        "cookie modal title": "我們使用Cookie",
        "cookie policy": "Cookie 政策",
        "essential cookies": "必要性 Cookie",
        "essential cookies description": "這些追蹤器僅用於執行您向我們請求的服務所必需的操作，且不會收集可用於行銷目的的個人資訊，亦不會記錄您的網路瀏覽歷史。此類Cookie無法停用。"
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "遠端裝置更新必備功能",
                "Standard": "進階自動化與整合功能",
                "Premium": "企業級擴展能力與更新功能的優先使用權"
            },
            "resource limit types": {
                "Companies": "企業",
                "Users": "使用者",
                "ConfigurationFiles": "設定檔"
            }
        },
        "empty state": {
            "description": {
                "configurations": "當 FOTA WEB 偵測到配置設定時，您將可在此處查看清單。",
                "firmware versions": "當韌體版本被 FOTA WEB 偵測到時，您將可在此處查看清單。"
            },
            "title": {
                "configurations": "未偵測到任何設定",
                "firmware versions": "未偵測到韌體版本",
                "news": "無最新消息可顯示"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "今日",
                "7": "7天",
                "30": "30天",
                "90": "90天"
            },
            "period": "週期"
        },
        "new": "",
        "news": {
            "body": {
                "1": "謹此提醒，自2025年1月7日起受邀註冊之用戶，帳戶啟用時將立即強制啟用雙重驗證（2FA）。雙重驗證可透過電子郵件驗證或驗證器應用程式完成。",
                "2": "謹此通知，FOTA WEB系統將於2025年6月3日世界協調時05:00起進行例行維護。請注意，維護期間所有服務將暫停運作，包含使用者介面、API存取、任務執行、OBD及CAN服務。預計服務中斷時間為1小時。",
                "3": "<section><p>我們很高興宣布 FOTA WEB 上的裝置解鎖功能獲得重大改進：</p></section> <section><p>所有使用者角色現可直接解鎖裝置——無需透過服務台聯繫技術支援！</p> <p>關鍵細節：</p> <ul><li>使用者可在 24 小時內對同一裝置解鎖最多 3 次。</li> <li>達上限後，解鎖功能將暫時停用24小時。</li> <li>若超出解鎖次數限制，系統將顯示錯誤訊息。此更新大幅縮短等候時間，讓您更有效掌控車隊管理。</li></ul></section> <section><a>瞭解功能使用方式</a></section>",
                "4": "<section><h3>全新裝置統計功能</h3> <p>透過兩款全新小工具，深入掌握裝置活動動態：</p> <p><strong>已啟用裝置</strong>： 此統計數據可顯示不同時間段內（今日、7天、30天或90天）已啟用（連線）的裝置數量。</p> <p><strong>已匯入裝置</strong>：同理，新增的「已匯入裝置」統計功能將追蹤今日、7天、30天或90天內匯入的裝置數量。</p> </section> <section><h3>任務小工具介紹</h3> <p>透過全新任務小工具掌握營運動態：</p> <p><strong>待辦任務</strong>：清晰顯示當前待處理任務數量。</p> <p><strong>任務概覽</strong>：依時間區間（7天、30天或90天）與狀態（已完成、完成但有錯誤、失敗）細分任務分布。</p></section> <section><h3>更智能的韌體與設定概覽</h3> <p>我們已優化韌體版本與設定小工具：</p> <ul><li>移除「未知」統計數據，呈現更簡潔的資訊。</li> <li>介面現可清晰顯示韌體與設定名稱及其數量。</li> <li>初始顯示前 5 名版本或設定，點擊「顯示更多」可查看最多 100 項不同條目。</li> <li>將滑鼠懸停或點擊特定韌體/設定項目，將導向「裝置頁面」並套用篩選條件。</li></ul></section> <section><h3>強化版新聞小工具</h3> <p>一瞥即知最新動態！新聞小工具採用嶄新設計，現在您還能點擊任何新聞項目閱讀完整資訊。</p></section> <section><h3>改良版裝置狀態</h3> <p>裝置狀態小工具已進行視覺更新，呈現更清晰。 此外，您現在可將滑鼠懸停於裝置狀態上，點擊後即可在「裝置」頁面篩選出具有相同狀態的裝置。</p></section> <section><p>我們希望這些更新能讓您的日常任務更輕鬆，並提供更多有價值的資訊。歡迎隨時告訴我們您的想法！</p></section>",
                "5": "<section><h3>預定 API 變更</h3></section> <section><p>我們將於 <strong>2025 年 9 月 24 日</strong> 移除回應中傳回使用者實體的「角色」欄位（例如 GET /users 或 GET /users/{userId} 端點）。此變更旨在為 FOTA WEB 鋪設更強大且靈活的權限系統基礎。</p></section> <section><h3>搶先預覽：角色與權限管理</h3></section> <section><p>我們深知現行角色系統未能滿足您的靈活性需求。開發團隊正全力打造全新<strong>角色與權限管理</strong>功能，讓您能建立具備細粒度權限控制的角色。</p></section> <section><p>此新系統將賦予您兩大權能：可為用戶指派固定角色，或依據特定需求量身訂製權限，並建立自訂角色。我們對此深感振奮，期待在功能上線時與您分享更多關於角色與權限管理的細節。</p></section>",
                "6": "<section><p>我們很高興宣布推出全新<strong>「角色與權限」</strong>功能，旨在讓您精準掌控FOTA WEB中的使用者存取權限。此功能可透過<strong>角色</strong>定義使用者能力，這些角色由特定<strong>權限</strong>組合而成（例如「建立任務」、「邀請使用者」）。 此功能包含三種不可變更的<strong>靜態角色</strong>——管理員、使用者與訪客——作為基礎安全防護，同時提供僅限<strong>企業高級版</strong>用戶建立或編輯的<strong>自訂角色</strong>。權限現已分類至裝置、任務與使用者等關鍵領域，您可將滑鼠懸停於管理區塊的「權限數量」處檢視詳細內容。 <strong>所有此更新前建立的現有使用者，均已自動指派「管理員」角色，確保其維持先前可執行的完整操作範圍。</strong></p></section> <section><p>此更新可提升安全性與工作負載分配效率。 角色現為企業專屬，無法跨企業架構繼承。請注意：邀請或將使用者移入企業時必須指派角色，且已指派給使用者的角色無法刪除。您現在可於<strong>使用者頁面</strong>使用<strong>全新「角色」篩選器</strong>簡化管理流程。立即探索「角色與權限」區段，為您的組織需求量身配置存取權限。</p></section> <section><p>欲獲取用戶與角色管理的詳細指南，請參閱<a>Wiki說明頁面</a>。</p></section>",
                "7": "<section><p>我們很高興推出強大的新功能——<strong>按日期排程</strong>，讓您能更精準地管理時間敏感的工作！</p></section> <section><h3>主要亮點</h3></section> <section><ul><li><strong>特定截止日期</strong> - 現在可透過全新「依日期排程」選項，將任務排定於<strong>特定日期或日期區間</strong>執行。</li> <li><strong>預設行為維持不變</strong> - 熟悉的<strong>依時間排程</strong>功能仍可完整使用。</li> <li><strong>到期狀態</strong> - 未於設定日期前完成的任務，狀態將自動變更為<strong>已過期</strong>，並顯示提示訊息：<strong>「任務未於設定時程內完成。」</strong></li> <li><strong>以使用者為中心的時區設定</strong> - 所有排程皆依據<strong>您的當地時間</strong>建立。</li></ul></section> <section><h3>運作原理</h3></section> <section><p>設定任務<strong>「依日期排程」</strong>時：</p> <ul><li>您將透過日期選擇器元件選取<strong>「開始日期」</strong>與<strong>「結束日期」</strong>。</li> <li>日期選擇器遵循公司層級任務到期時限。</li></ul></section><section><p><strong>按日期排程</strong>功能目前僅限高階公司層級使用，<strong>基本</strong>方案無法啟用此功能。</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "自2025年1月7日起，新用戶強制啟用雙重驗證（2FA）",
                "2": "2025年6月3日計劃維護",
                "3": "新功能更新：所有使用者皆可更輕鬆地解鎖裝置",
                "4": "探索儀表板上的最新動態！",
                "5": "重要：即將實施的 API 變更與角色權限功能搶先看",
                "6": "全新功能現已推出：透過「角色與權限」實現強化管控",
                "7": "新功能：透過日期設定任務排程，實現更高靈活性",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "發佈於",
        "take me there": "帶我前往",
        "tasks": {
            "current": "現況",
            "status": {
                "completed": "已完成",
                "completed_with_errors": "已完成但存在錯誤",
                "failed": "失敗",
                "no tasks": "無任務"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7天",
                "tooltipTitle": "過去7天"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30天",
                "tooltipTitle": "過去30天"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90天",
                "tooltipTitle": "過去90天"
            }
        },
        "title": {
            "activated": "已啟用的裝置",
            "configurations": "設定",
            "device status": "裝置狀態",
            "firmware versions": "韌體版本",
            "imported": "已導入的裝置",
            "news": "最新消息",
            "queued tasks": "佇列任務",
            "refreshed every hour": "每小時更新",
            "resource limits": "資源限制",
            "task overview": "任務概覽",
            "tasks": "任務"
        },
        "tooltips": {
            "activated": "在指定期間內首次連線至FOTA WEB的裝置數量（今日、過去7天、過去30天、過去90天）。",
            "configurations": "顯示已上傳至裝置的設定檔名稱分佈情況。最多可顯示100個獨特檔名。",
            "firmware versions": "顯示您所連接裝置回報的韌體版本分佈情況。最多可顯示100個獨特版本。",
            "imported": "在所選期間內（今日、過去7天、過去30天、過去90天）新增至您帳戶的裝置數量。"
        }
    },
    "Date picker": {
        "disableFuture": "無效日期",
        "disablePast": "無效日期",
        "invalidDate": "無效日期",
        "maxDate": "錯誤日期",
        "minDate": "錯誤日期",
        "shouldDisableDate": "無效日期",
        "shouldDisableMonth": "無效日期",
        "shouldDisableYear": "無效日期"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "新增裝置",
        "add new device description": "將單一或多個新裝置新增至選定的公司與群組。僅需標記「匯入為舊版裝置」核取方塊，即可匯入如FM或FMA等舊版裝置。",
        "add new device legacy title": "以舊有裝置形式匯入。",
        "add new device legacy description": "將「建立日期」設為 2016.01.01，並將「型號」設為舊版。",
        "add new product code": "新增產品代碼",
        "add new product code description": "新增裝置產品代碼並將其連結至可用CAN套件。",
        "all permissions": "所有權限",
        "assign access group": "",
        "assign can package description": "選擇方案類型並將其指派給所有選取的裝置。",
        "assign role": "指派角色",
        "attribute value": "屬性值",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "開始下載",
        "by date": "依日期排序",
        "by time": "按時間",
        "can adapter": "CAN匯流排轉接器",
        "cancel pending tasks": "取消相同任務類型的待辦任務",
        "cancel tasks": "取消任務",
        "cancel tasks in group": {
            "alert title": "此操作最多需數分鐘方能完成。",
            "banner description": "若需查看任務的最新狀態，請參閱任務群組詳情或重新整理頁面。",
            "banner title": "此操作將耗時數分鐘完成，具體時間取決於任務數量。",
            "description": "點擊「接受」將取消所有待處理及執行中的任務。您確定要繼續嗎？",
            "title": "取消群組內所有任務？"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "客戶代表電子郵件",
        "companies": "企業",
        "company": "公司",
        "company level": {
            "Basic": "基礎",
            "Internal": "內部",
            "Premium": "高級版",
            "Standard": "標準"
        },
        "company level change description": "升級公司等級時，請選擇新等級並說明升級原因。公司等級無法降級。所有日期均以UTC時間為準。",
        "company level manual revert": {
            "confirmation": {
                "description": "此操作將將公司層級重設為系統自動分配的「{{companyLevel}}」層級。請確認是否繼續執行？",
                "title": "撤銷手動層級變更？"
            },
            "description": "還原操作將使公司層級恢復至系統自動分配的等級。",
            "title": "此公司級別已手動升級至{{expirationDate}}。"
        },
        "company level type": "企業級類型",
        "company name": "公司名稱",
        "company statistics": {
            "child companies": "子公司數量統計",
            "devices": "裝置數量",
            "files": "檔案數量",
            "groups": "裝置群組數量",
            "tasks": "任務計數",
            "users": "用戶數量"
        },
        "company type": {
            "All": "",
            "Client": "客戶端",
            "Internal": "內部",
            "Virtual": "虛擬"
        },
        "configuration": "設定",
        "confirmations": {
            "are you sure": "您確定嗎？",
            "are you sure you wish to continue": "您確定要繼續嗎？",
            "assign can package confirmation": "您確定要將所選套件指派給指定數量的裝置嗎？",
            "cancel task confirmation": {
                "first part": "您確定要取消指定數量的任務嗎？",
                "second part": "若屬實，請輸入受影響任務數量並點擊「確認」。"
            },
            "create task confirmation": "您確定要為指定數量裝置建立任務嗎？",
            "delete resource confirmation": {
                "first part": "您確定要刪除指定數量的 {{resource}} 嗎？",
                "second part": "若屬實，請輸入受影響的 {{resource}} 數量並點擊「刪除」。"
            },
            "delete resources": {
                "companies": "企業",
                "files": "檔案",
                "groups": "裝置群組",
                "deviceModels": "模型",
                "productCodes": "產品代碼",
                "roles": "角色",
                "users": "使用者"
            },
            "description second part": "若屬實，請輸入受影響裝置數量並點擊「確認」。",
            "export device data confirmation": "您確定要匯出指定數量裝置的裝置資料嗎？",
            "file": "請輸入檔案中現存的行數",
            "filter": {
                "companies": "請輸入篩選後的企業數量",
                "devices": "請輸入過濾後的裝置數量",
                "files": "請輸入過濾後的檔案數量",
                "groups": "輸入已過濾裝置群組的數量",
                "productCodes": "請輸入過濾後的產品代碼數量",
                "tasks": "輸入已過濾任務的數量",
                "users": "輸入過濾後的用戶數量"
            },
            "id_list": {
                "companies": "請輸入所選企業數量",
                "devices": "請輸入所選裝置的數量",
                "files": "請輸入所選檔案的數量",
                "groups": "請輸入所選裝置群組的數量",
                "productCodes": "請輸入所選產品代碼的數量",
                "tasks": "輸入所選任務的數量",
                "users": "請輸入所選用戶的數量"
            },
            "merge companies confirmation": "您即將合併 {{sourceCompany}} 與 {{targetCompany}} 兩家公司。",
            "move companies confirmation": "您即將將 {{sourceCompany}} 遷移至 {{targetCompany}} 公司。",
            "move devices confirmation": "您確定要將指定數量的裝置移轉至另一家公司嗎？",
            "number of lines": "行數",
            "selected 20 or more devices": "您已選取 20 個或更多裝置...",
            "transfer devices confirmation": "您確定要將指定數量的裝置轉移至另一家公司嗎？"
        },
        "confirm cannot revert": "此操作無法撤銷。",
        "confirm merge companies": "您確定要合併這些公司嗎？",
        "count": "計數",
        "create company": "建立公司",
        "create company description": "在所選母公司下建立新公司。",
        "create desktop license": "建立desktop授權",
        "create desktop license description": "為客戶公司簽發新的線上FOTA Desktop授權，包含其IP位址、硬體金鑰及有效期限（最長兩年）。",
        "create group": "建立群組",
        "create group description": "將裝置分組管理，簡化操作流程並實現批次指派。",
        "create model": "建立模型",
        "create model description": "建立新裝置模型時需指定名稱、平台及TCT web支援功能。",
        "create offline license": "建立離線授權",
        "create or edit group description": "韌體與設定可分配至群組。完成分配後，系統將為所有群組成員（裝置）自動生成韌體及/或設定更新任務。",
        "create role": "建立角色",
        "create role description": "建立新角色時，需指定名稱與描述、選擇所屬公司，並賦予特定權限。",
        "create smart group": "建立智慧群組",
        "create smart group banner message": "",
        "create smart group description": "可為各平台的設備群組指派韌體與設定檔。檔案指派完成後，系統將自動為群組內所有設備生成更新任務。",
        "create task description first step": "可建立多種任務類型，從更新設定檔或韌體，到接收指定或篩選設備的日誌、配置等資料皆能涵蓋。此外，您還能為建立的任務排程，提升操作便利性。",
        "create task description last step": "在建立任務前，請確認以下資訊正確無誤。",
        "current level": "當前層級",
        "custom resource limits": {
            "at least one limit must be higher": "至少應有一項限制值高於預設的 Premium 等級數值。",
            "configuration files per device": "每台裝置專屬設定檔",
            "confirmation modal description": "您確定要變更公司「{{companyName}}」的下列資源限制嗎？",
            "confirmation modal title": "變更公司資源限制？",
            "count": {
                "companies count": "企業數量：{{number}}",
                "configuration files per device count": "每台裝置的設定檔數量：{{number}}",
                "tasks per group count": "每組任務數量：{{number}}",
                "users count": "使用者數量：{{number}}"
            },
            "explanations": {
                "companies": "企業層級結構中可建立的子公司總數。",
                "configuration files per device": "可儲存的配置檔案數量，每台裝置對應一個配置檔案。每家企業層級最低保證配置檔案數量為100個。",
                "tasks per group": "單一任務群組可包含的任務數量。",
                "users": "企業層級中可建立的總使用者數量。"
            },
            "main modal description": "為不同資源類型（如企業、使用者、任務群組中的任務或設定檔）設定自訂資源配額。自訂資源將持續生效至高級版到期或手動重置為止。",
            "resources limit type": "資源限制類型",
            "revert custom resource limits": "恢復自訂資源限制",
            "revert custom resource limits description": "重置所有限制將恢復預設資源值，並將公司等級變更為高級版。",
            "revert custom resource limits description confirmation": "此操作將將資源限制恢復為「高級」等級的自動分配值。您確定要繼續嗎？",
            "revert custom resource limits title": "該公司的資源限制已手動設定。",
            "revert custom resource limits title confirmation": "恢復自訂資源限制？",
            "tasks per group": "各群組任務"
        },
        "date range": "日期範圍",
        "date to": "至",
        "delete companies": "刪除公司",
        "delete deviceModels": "刪除模型",
        "delete files": "刪除檔案",
        "delete file warning": "刪除檔案將取消相關任務及任務群組。",
        "delete groups": "刪除裝置群組",
        "delete productCodes": "刪除產品代碼",
        "delete roles": "刪除角色",
        "delete tasks and history": "",
        "delete users": "刪除使用者",
        "description": "描述",
        "desktop license delete description": "您確定要刪除Desktop版授權「{{name}}」嗎？",
        "desktop license name": "Desktop授權名稱",
        "device identifier": "裝置識別碼",
        "device transfer": {
            "main": {
                "description": "透過接收公司生成的代幣，將選取或篩選後的裝置移轉至無關聯企業。",
                "title": "裝置轉移"
            },
            "receive devices": {
                "copy token": "將生成的驗證碼複製並傳送給負責將設備從其公司轉移至貴公司的相關人員。",
                "description": "建立接收裝置的驗證碼並傳送至轉移公司。",
                "token info": "此通行證為一次性使用，有效期為21天後失效。"
            },
            "transfer devices": {
                "confirmation": "您確定要將裝置轉移至以下公司？",
                "device token": "設備轉移令牌必須向您欲轉移設備至之公司的管理員取得。",
                "transfer from file": "上傳包含設備清單（IMEI碼）的檔案，即可將您公司欲轉移的設備資料傳輸至您剛輸入其代幣的目標公司。"
            }
        },
        "device transfer token": "裝置傳輸令牌",
        "downgrading company level is not possible": "無法降級公司層級",
        "download sample file message": "下載 <1>範例 CSV 模板</1> 以查看所需格式的範例。",
        "edit group banner message": "變更韌體和/或設定檔將取消所有同類型先前待處理的任務。",
        "edit group description": "修改此裝置群組的設定。",
        "edit role description": "自訂角色的名稱、描述及權限。已指派的公司無法變更。",
        "edit smart group description": "可針對各平台的設備群組指派或變更韌體與設定檔。文件指派或變更後，系統將為群組內所有設備自動生成更新任務。",
        "email": "電子郵件",
        "enter": "輸入",
        "enter code": "輸入代碼",
        "enter description": "輸入描述",
        "enter name": "輸入名稱",
        "example": "例如：",
        "expires at": "到期時間：",
        "explanation": "說明",
        "export device data": "匯出裝置資料",
        "export device description": "",
        "export file format": "輸出檔案格式",
        "feature": "功能",
        "feature control": "功能控制",
        "field disabled until company selected": "此欄位在選擇公司前將保持停用狀態。",
        "firmware": "韌體",
        "files to download": "待下載檔案",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "上傳的1-Wire授權清單將自動排序，以提升功能運作的速度與精準度。",
                "bluetooth_authorization_list": "上傳的藍牙授權清單將自動排序，以提升功能運作的速度與精準度。"
            },
            "endings": {
                "file": "檔案",
                "files": "檔案"
            },
            "fail": {
                "multiple": "{{failCount}} 個 {{fileEnding}} 檔案因錯誤未能上傳，總計 {{totalCount}} 個檔案。",
                "single": "{{failCount}} 個 {{fileEnding}} 檔案因錯誤未能上傳，總計 {{totalCount}} 個檔案。"
            },
            "success": {
                "multiple": "所有檔案已成功新增至所選企業。",
                "single": "所有檔案已成功新增至所選公司。"
            }
        },
        "filtered": "過濾",
        "filtered companies": "篩選後的企業",
        "filtered devices": "過濾裝置",
        "filtered files": "過濾後的檔案",
        "filtered groups": "篩選群組",
        "filtered tasks": "過濾任務",
        "filtered users": "過濾後的使用者",
        "find tool": {
            "device": {
                "error not valid": "IMEI 必須由 15 個字元組成",
                "error subtitle": "裝置未找到。請嘗試輸入其他 IMEI 號碼。",
                "error title": "未找到任何裝置",
                "link": "前往裝置",
                "no permission": "您無權查看此裝置。"
            },
            "user": {
                "error not valid": "電子郵件格式無效",
                "error subtitle": "未找到使用者。請嘗試輸入其他使用者電子郵件。",
                "error title": "未找到使用者",
                "link": "前往使用者",
                "no permission": "您沒有權限查看此使用者。"
            }
        },
        "firmware date": "韌體日期",
        "from form": "表單來源",
        "from file": "從檔案",
        "general": "通用",
        "gsm_number": "GSM號碼",
        "iccid": "ICCID",
        "imei": "國際移動設備識別碼",
        "imei restriction": "IMEI限制",
        "import device data": "匯入裝置資料",
        "import device data description": "將指定清單中裝置的選取屬性資料匯入系統。",
        "import device data info": "每個屬性皆有顯示於括號內的最大字元限制。若屬性內容超過最大限制，系統將自動截斷至最大限制長度。",
        "import device data limit": "(最多 {{limit}} 個字元)",
        "imsi": "IMSI",
        "input text too long": "文字過長。最多允許 {{maxLength}} 個字元。",
        "invalid hardware key": "無效的硬體金鑰格式",
        "invalid imei": "IMEI 號碼無效",
        "invalid ipv4": "無效的 IPv4 格式",
        "invalid serial": "序號無效",
        "invalid value": "無效值",
        "inverted selection": "反向篩選",
        "invite user": "邀請使用者",
        "invite user description": "邀請新用戶加入所選母公司並設定其角色。發送後，用戶將有30天時間接受邀請，逾期邀請即失效。",
        "invite user max roles": "最多允許設定5個角色。請取消選取其中一個角色以繼續操作。",
        "log files": "日誌檔案",
        "make": "建立",
        "manage permissions": "管理所有帳戶及站點層級的數據。",
        "maximum value is": "最大值為 {{value}}",
        "merge companies": "合併公司",
        "merge companies info": "所有來源公司的資源（裝置、群組、檔案、公司、使用者及其角色）將移轉至目標公司。建議在合併前檢視使用者角色設定。後續將刪除來源公司。",
        "merge companies disabled option": {
            "client to internal": "客戶型公司無法併入內部型公司。",
            "internal": "內部型公司無法合併。",
            "lz code": "帶有代碼的公司無法合併。"
        },
        "minimum value is": "最小值為 {{value}}",
        "move companies disabled option": {
            "internal": "內部型公司無法移動。"
        },
        "move device": "移動裝置",
        "move device description": "將選取或篩選後的裝置移至公司層級結構中的現有公司及／或群組。",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "移動裝置",
        "name": "名稱",
        "newest": "從最新",
        "no dropdown files": {
            "description": "若要選擇此選項，請上傳新的 $t(Dialog##no dropdown files##file names##{{fileName}}) 檔案。",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "1-Wire授權清單",
                "adas_firmware": "先進駕駛輔助系統韌體",
                "ble_fw": "BLE韌體",
                "blue_nrg": "BlueNrg 韌體",
                "bluetooth_authorization_list": "藍牙授權清單",
                "can_chip_firmware": "FM CAN晶片韌體",
                "carrier_advance_firmware": "Carrier Advance 韌體",
                "carrier_advance_settings": "Carrier Advance設定",
                "carrier_apx_firmware": "Carrier APX 韌體",
                "carrier_apx_settings": "Carrier APX 設定",
                "certificate": "TLS 憑證",
                "configuration": "設定",
                "dsm_firmware": "DSM 韌體",
                "dtb": "DTB",
                "firmware": "韌體",
                "fw_bundle": "韌體套件",
                "gnssm_download_assistant": "GNSS-M 下載助手",
                "gnssm_firmware": "GNSS-M 韌體",
                "main configuration": "",
                "manual_geofence_list": "手動地理圍欄情境清單",
                "meig_modem_firmware": "美格數據機韌體",
                "netprisma_modem_firmware": "NETPRISMA 數據機韌體",
                "psub": "訂閱服務",
                "quectel_modem_firmware": "Quectel 數據機韌體",
                "simcom_modem_firmware": ""
            },
            "main": "沒有 $t(Dialog##no dropdown files##file names##{{fileName}}) 檔案。"
        },
        "none": "無",
        "obd oem": "OBD 原廠設備製造商",
        "offline license delete description": "您確定要刪除離線授權「{{name}}」嗎？",
        "oldest": "從最舊的",
        "only integers": "僅整數為有效值",
        "only numbers": "僅數字有效",
        "optional": "可選",
        "other companies": "其他公司",
        "parent company": "母公司",
        "permission preset": "權限預設",
        "platform compatibility": {
            "banner text": "部分已選取的裝置型號與所選任務類型不相容。對於不相容的裝置型號，此任務類型將不會預設建立。",
            "compatible model devices": "相容裝置型號",
            "count text": "任務將針對 {{totalCount}} 台裝置中的 <1>{{compatibleCount}}</1> 台裝置建立。",
            "create tasks for incompatible devices": "為不相容裝置建立任務。",
            "devices from file": "裝置來源：檔案",
            "platform": "{{title}} 平台",
            "task applies": "任務適用於",
            "task cannot be created": "無法為不相容的裝置型號建立任務。"
        },
        "receiving company": "本公司將接收您的裝置",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "此操作最多需數分鐘方能完成。",
            "banner description": "若需查看任務的最新狀態，請參閱任務群組詳情或重新整理頁面。",
            "description": "按下「接受」將重新嘗試所有失敗任務。您確定要繼續嗎？",
            "title": "是否重試該群組中的所有任務？"
        },
        "revision": "修訂版",
        "revision value error": "數值必須為兩位數（00 - 99）。",
        "role name": "角色名稱",
        "root company": "母公司",
        "sales email": "銷售經理電子郵件",
        "scheduled time warning": "具備排程時間的任務不會變更裝置的FOTA連線時間設定。若裝置在選定的時間區間內連線至FOTA WEB，任務將自動執行。請確保裝置設定的連線間隔時間不短於所選時間區間。",
        "schedule task": "排程任務",
        "select": "選擇",
        "select at least one": {
            "companies": "請至少選擇一家公司",
            "devices": "請至少選擇一個裝置",
            "files": "請至少選擇一個檔案",
            "groups": "請至少選擇一個群組",
            "tasks": "請至少選擇一項任務",
            "users": "請至少選擇一位使用者"
        },
        "selected": "精選",
        "selected companies": "精選企業",
        "selected deviceModels": "精選型號",
        "selected devices": "已選取的裝置",
        "selected files": "已選取的檔案",
        "selected groups": "已選取的裝置群組",
        "selected productCodes": "精選產品代碼",
        "selected roles": "選定角色",
        "selected tasks": "精選任務",
        "selected users": "精選用戶",
        "select company": "",
        "select group": "",
        "select time interval": "選擇時間間隔",
        "selected time window": "選取時間區間：{{fromDate}} 至 {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "為 {{platformName}} 平台裝置選取可用檔案。",
            "title": "{{platformName}} 平台檔案"
        },
        "sn": "序號",
        "specific": "特定",
        "time period": "時間段",
        "time period custom": "客製化",
        "tls certificate transfer info": "",
        "token has expired": "代幣已過期",
        "token is valid": "代幣有效",
        "transfer companies": "轉移公司",
        "transfer companies description": "選擇是否移動或合併兩家公司。部分操作無法撤銷。",
        "transfer devices": "傳輸裝置",
        "tri source": {
            "selected tab description": {
                "create task": "選取的任務將透過勾選框為指定裝置建立。",
                "general": "選取的操作將透過勾選框對所選裝置執行。"
            },
            "filtered tab description": {
                "create task": "所選任務將針對符合篩選條件的裝置建立，可運用一個或多個可用篩選器進行篩選。",
                "general": "系統將依據設定的篩選條件，對符合條件的裝置執行指定操作。"
            },
            "from file tab description": {
                "create task": "系統將根據上傳檔案中指定的裝置，自動建立對應的任務。",
                "general": "系統將對上傳檔案中指定的裝置執行所選操作。"
            }
        },
        "unlocker": {
            "generate unlock key": "生成解鎖金鑰",
            "generate unlock key description": "請於下方欄位輸入TCT提供的裝置「鎖定代碼」。點擊「產生」按鈕生成解鎖金鑰，並於TCT中使用該金鑰解鎖您的裝置。",
            "invalid lock code": "裝置鎖定代碼無效。",
            "limit reached": "您已達到生成解鎖金鑰的最大數量。",
            "lock code": "鎖定代碼",
            "select device platform": "選擇裝置平台",
            "select device platform description": "請選擇正確的裝置平台。車載通訊裝置分為三代平台：<1>FT</1>（FTx、ATx）、<2>FMx</2>（各類FM、FMT、TAT、MSP、TFT、TST、GH及TMT型號），以及<3>舊版</3>（早期FM、FMA及GH型號）。",
            "unlock key": "解鎖金鑰",
            "unlock key success message": "解鎖金鑰已成功生成。"
        },
        "upload file": "上傳檔案",
        "upload file description": "透過拖放區域或選取功能，一次最多可上傳 {{count}} 個檔案。",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "04.00.00 及以上版本韌體包含降級防護機制。韌體變更詳情請參閱我們的文件：<1>Teltonika GPS Wiki</1>。按下「下一步」按鈕即表示您同意並理解上述資訊。",
        "upload firmware unsupported info": "此版本暫無更新可用，請聯繫 Teltonika 技術支援或您的 Teltonika 業務經理。",
        "use at least one filter": "請至少使用一個篩選條件",
        "user": "使用者",
        "valid until": "有效期至",
        "valid until date disable description": "此欄位僅在「時間區間」設定為「自訂」時方可修改",
        "vehicle model": "模型"
    },
    "Dropzone": {
        "add file": "新增檔案",
        "add files": "新增檔案",
        "drop file to upload": "將檔案拖放至此處即可上傳",
        "drop files to upload": "拖放檔案即可上傳",
        "error uploading the file": "上傳檔案時發生錯誤",
        "file invalid type": "您選擇的檔案類型無效。",
        "file successfully uploaded": "檔案已成功上傳",
        "file syntax": "檔案語法如下：",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "已達到最大檔案限制。",
        "only one file can be attached": "僅限附加單一檔案。",
        "or drop file to upload": "或拖放檔案進行上傳",
        "or drop files to upload": "或拖放檔案進行上傳",
        "rows detected": "檔案中的行已成功偵測",
        "select file": "選擇檔案",
        "select files": "選擇檔案",
        "select file type": "請先選擇檔案類型。",
        "supported formats": "支援格式",
        "too long file name": "檔案名稱過長。最多允許 {{maxLength}} 個字元。",
        "too many files description": "選取檔案上傳後，其餘檔案即可進行上傳。",
        "too many files title": "單次最多可附加 {{maxFiles}} 個檔案。"
    },
    "Error": {
        "error": "錯誤",
        "message wait": "請耐心等待，我們正在修復此錯誤。",
        "title": "發生錯誤！"
    },
    "Feature highlight": {
        "got it": "明白了",
        "new feature": "新功能！",
        "scenarios description": "現在，您可在裝置上設定以下任一情境：超速偵測、碰撞偵測或拖曳偵測。"
    },
    "Filter": {
        "access group": "",
        "activity_status": "狀態",
        "all permissions": "所有權限",
        "batch_id": "批次識別碼",
        "company_id": "公司",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "由",
        "current_configuration": "設定",
        "current_firmware": "韌體",
        "device_imei": "裝置 IMEI",
        "file type": "檔案類型",
        "filtered by": "篩選條件：",
        "filters used": "使用的過濾器",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "群組",
        "id": "ID",
        "Invalid company": "無效公司",
        "model": "模型",
        "model_platform": "平台",
        "Multiple companies": "多家企業",
        "parent company": "母公司",
        "permission": "權限",
        "permission status": "狀態",
        "role": "角色",
        "spec_id": "Spec ID",
        "status_id": "狀態",
        "supported_task_type": "任務類型",
        "table filters": "表格篩選器",
        "task type": "任務類型",
        "task_queue": "佇列",
        "type": "類型",
        "user status": "狀態"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "ADAS韌體檔案大小不可為零。",
        "ADAS firmware is invalid.": "ADAS韌體無效。",
        "All notifications were deleted.": "所有通知均已刪除。",
        "All notifications were marked as read.": "所有通知均已標記為已讀。",
        "At least one user role must be provided.": "至少需提供一個使用者角色。",
        "Attributes length is invalid": "屬性長度無效。",
        "Banner was updated.": "",
        "Batch was discarded": "批次已被棄用。",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "已建立批次屬性更新任務。裝置屬性將於稍後更新。",
        "Bulk create job was created. Devices will be created shortly.": "已建立批次建立任務。裝置將於稍後建立。",
        "Bulk create job was created. Tasks will be created shortly.": "已建立批次建立工作。任務將於稍後建立。",
        "Bulk delete job was created. Companies will be removed shortly.": "已建立批次刪除任務。相關企業資料即將移除。",
        "Bulk delete job was created. Devices will be removed shortly.": "已建立批次刪除任務。裝置將於稍後移除。",
        "Bulk delete job was created. Files will be removed shortly.": "已建立批次刪除任務。檔案將於稍後移除。",
        "Bulk delete job was created. Groups will be removed shortly.": "已建立批次刪除任務。群組將於稍後移除。",
        "Bulk delete job was created. Product codes will be removed shortly.": "已建立批次刪除任務。產品代碼將於稍後移除。",
        "Bulk delete job was created. Users will be removed shortly.": "已建立批次刪除任務。用戶資料即將移除。",
        "Bulk task create job was created. Tasks will be created shortly.": "批次任務已建立，任務項目即將顯示。您可在「任務群組」頁面下的任務群組詳細資訊中查閱任務。",
        "Bulk update job was created. Devices will be updated shortly.": "已建立批次更新任務，裝置將於稍後進行更新。",
        "Bulk update job was created. Tasks will be updated shortly.": "已建立批次更新任務。相關項目將於稍後進行更新。",
        "Can adapter was added.": "已新增 Can 轉接器。",
        "Can adapter was deleted.": "Can 轉接器可能已被刪除。",
        "Can adapter was updated.": "Can 轉接器已更新。",
        "Can chip firmware file size can't be zero": "晶片韌體檔案大小不可為零。",
        "Can chip firmware is invalid.": "晶片韌體可能無效。",
        "Cannot delete company. Company is not empty.": "無法刪除公司。該公司尚未清空。",
        "Cannot delete file. It is used by pending or running tasks.": "無法刪除檔案。該檔案正用於待處理或執行中的任務。",
        "Cannot delete file. It is used by running tasks.": "無法刪除檔案。該檔案正被執行中的任務使用。",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "無法刪除已分配給裝置的產品代碼。",
        "check your email for details": "",
        "Companies count limit exceeded.": "企業數量上限已達。",
        "Companies in the request must belong to the selected root.": "申請企業必須隸屬於所選根目錄。",
        "Company merge job was created. It will be merged shortly.": "公司合併任務已建立，即將進行合併。",
        "Company name already exist.": "公司名稱已存在。",
        "Company level change is not allowed.": "不允許進行公司層級的變更。",
        "Company level successfully changed": "公司層級已成功變更。",
        "company level successfully reverted": "公司層級已成功恢復至自動分配層級。",
        "Company not allowed to be merged": "公司不得進行合併。",
        "company resource limits changed": "公司資源限制已成功變更。",
        "Company was created.": "公司已成立。",
        "Company was deleted.": "公司已被刪除。",
        "Company was updated.": "公司資訊已更新。",
        "compatibilities added": "同步期間新增 {{count}} 項相容性。",
        "compatibilities synchronized": "成功同步了缺失的相容性。",
        "Configuration cannot have FOTA functionality disabled": "設定中不得禁用 FOTA 功能。",
        "Configuration file cannot contain duplicate parameters": "設定檔不得包含重複參數。",
        "Configuration file size can't be zero": "設定檔大小不可為零。",
        "Configuration files count limit exceeded.": "設定檔數量已超過限制。",
        "Configuration version must be defined": "必須定義配置版本。",
        "custom resource limits successfully reverted": "自訂資源限制已成功恢復為系統自動分配的預設值。",
        "Custom roles feature is not enabled.": "自訂角色功能僅限擁有企業級進階方案的使用者啟用。先前建立的自訂角色可被刪除。",
        "desktop license added": "Desktop授權「{{name}}」已成功新增。",
        "Devices already are in target company": "設備已部署於目標企業。",
        "Device already exists.": "裝置已存在。",
        "Device bulk attribute update file cannot be empty": "裝置批次屬性更新檔案不可為空。",
        "Device bulk attribute update file should be .csv": "裝置批次屬性更新檔案格式應為 .csv。",
        "Device export limit reached. You can not export more than 100000 devices": "已達到裝置匯出上限。您無法匯出超過 100,000 個裝置。",
        "Device import limit reached. You can not import more than 100 devices": "已達到裝置匯入上限。您無法匯入超過 100 台裝置。",
        "Device model and task type compatibility was updated.": "已更新裝置型號與任務類型的相容性。",
        "Device model was created.": "已建立裝置模型。",
        "Device model was deleted.": "裝置型號已刪除。",
        "Device model was updated.": "裝置型號已更新。",
        "Device not found": "裝置未找到。",
        "Device Transfer job was created. Devices will be transfered shortly.": "裝置轉移任務已建立。裝置將於稍後進行轉移。",
        "Device was added.": "已新增裝置。",
        "Device was deleted.": "裝置已刪除。",
        "Device was updated.": "裝置已更新。",
        "Email or password is incorrect.": "您輸入的電子郵件或密碼不正確。",
        "Failed to create Product code": "建立產品代碼失敗。",
        "Failed to delete Product code": "無法刪除產品代碼。",
        "Failed to import devices.": "裝置匯入失敗。",
        "Failed to Read Product code": "讀取產品代碼失敗。",
        "Failed to retry failed tasks": "未能重試失敗任務。",
        "Failed to update Product code": "產品代碼更新失敗。",
        "Failed to update task for retry": "未能重試失敗任務。",
        "Field is not valid": "欄位無效。",
        "File description is too long. Max 255 characters allowed.": "檔案描述過長。最多允許 255 個字元。",
        "File exceeds entries limit of 10000.": "該檔案超過 10,000 項的輸入限制。",
        "File must not contain duplicated IMEIs": "檔案內不得包含重複的IMEI編號。",
        "File must not contain IMEIs that already exist in database.": "檔案內容不得包含資料庫中已存在的IMEI編號。",
        "File must not contain invalid IMEIs": "檔案不得包含無效的 IMEI 號碼。",
        "File name is too long. Max 255 characters allowed.": "檔案名稱過長。最多允許 255 個字元。",
        "File name should not contain illegal characters or symbols": "檔案名稱不得包含任何特殊字元。",
        "File not found": "檔案未找到。",
        "File was deleted.": "檔案已刪除。",
        "File was successfully uploaded.": "檔案已成功上傳。",
        "File was updated.": "檔案已更新。",
        "File was uploaded. Devices will be imported shortly.": "檔案已上傳。裝置將稍後匯入。",
        "File will be created shortly. Check files in a second.": "檔案即將建立。請稍候片刻即可查看檔案。",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "韌體檔案大小不可為零。",
        "First device in file not found.": "檔案中第一個裝置未找到。",
        "Forbidden": "禁止。",
        "Group name already exist.": "群組名稱已存在。",
        "Group was added.": "\"'{{group}}'\" 已成功建立。",
        "Group was created.": "群組已建立。",
        "Group was deleted.": "群組已刪除。",
        "Group was updated.": "群組已更新。",
        "Invalid device bulk update attribute": "無效裝置批次更新屬性。",
        "Invalid email address.": "無效的電子郵件地址。",
        "Invalid file contents": "檔案內容無效。",
        "Invalid file name": "無效的檔案名稱。",
        "Invalid invitation token.": "邀請代幣無效。",
        "Invalid token": "無效的憑證。",
        "Invalid token length": "無效的代幣長度。",
        "Internal Server Error": "內部伺服器錯誤。",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "授權已被刪除。",
        "License was updated.": "授權已更新。",
        "Maximum companies hierarchy depth exceeded": "最大公司層級深度已超過限制",
        "Maximum device group size exceeded.": "最大裝置群組大小已超過限制。",
        "Method Not Allowed": "方法不被允許。",
        "Network Error": "網路錯誤。",
        "No changes made": "未進行任何變更。",
        "No resources found.": "未找到任何資源。",
        "not allowed to affect batch": {
            "description": "請確認您已取得控制權限，可管理建立此任務群組的使用者所屬公司。",
            "title": {
                "approve": "您無權批准此批次。",
                "discard": "您無權限捨棄此批次。"
            }
        },
        "Not Found": "未找到。",
        "Notification was deleted.": "通知已刪除。",
        "notify when done title": "此操作可能需要一段時間。請按下下方按鈕關閉此畫面，完成後您將收到通知。",
        "Obd record was created.": "已建立OBD記錄。",
        "Obd record was updated.": "OBD記錄已更新。",
        "offline license added": "離線授權「{{name}}」已成功新增。",
        "Offline license was deleted.": "離線授權已被刪除。",
        "Only id_list source is supported.": "僅支援 id_list 來源。",
        "Only users with Teltonika email can be invited into internal companies.": "僅限持有Teltonika電子郵件的用戶可被邀請加入內部企業。",
        "Only users with Teltonika email can be moved into internal companies.": "僅限持有 Teltonika 電子郵件的用戶可移入內部公司。",
        "Parent company cannot be a descendant of the updated company.": "母公司不得為更新後公司的後代。",
        "Password reset link was sent to Your email.": "密碼重設連結已發送至您的電子郵件。",
        "Password reset token is invalid, expired or related user no longer exists.": "密碼重設代幣無效、已過期或使用者已不存在。",
        "Password was changed.": "密碼已變更。",
        "product code added": "產品代碼「{{code}}」已成功新增。",
        "Product code is too long. Max 200 characters allowed.": "產品代碼過長。最多允許 200 個字元。",
        "ProductCode already exists.": "產品代碼已存在。",
        "ProductCode not found": "產品代碼未找到。",
        "Product code was deleted.": "產品代碼已刪除。",
        "Product code was updated.": "產品代碼已更新。",
        "Retry failed tasks job was created": "已建立重試失敗任務的工作項。",
        "Role cannot be set for an internal user.": "內部使用者無法設定角色。",
        "Role was created.": "角色已建立。",
        "Role was deleted.": "角色已被刪除。",
        "Role was updated.": "角色已更新。",
        "selected company changed": "所選公司已變更。",
        "Selected firmware bundle is not supported by the device.": "所選固件套件不被該裝置支援。",
        "Server Error": "伺服器錯誤。",
        "SMS was sent.": "已發送簡訊。",
        "Something went wrong while saving a new password.": "儲存新密碼時發生錯誤。",
        "Successfully logged out.": "已成功登出。",
        "System Admin user level is required in order to perform this action.": "執行此操作需具備系統管理員使用者權限。",
        "Target company cannot be a descendant of source company.": "目標公司不得為來源公司的後代。",
        "Task create limit exceeded.": "您無法為超過 100,000 個裝置建立任務群組。",
        "Task type is not retriable": "任務類型不可重試",
        "Task was added.": "任務已新增。",
        "task was created": "此任務已為 {{imei}} 建立（「{{taskType}}」）。您可在裝置詳情頁的「裝置」分頁下，於「任務」區塊中找到此任務。",
        "Task was updated.": "任務已更新。",
        "Tasks were approved": "任務已獲批准。",
        "The given data was invalid.": "所提供的資料無效。",
        "time zone changed": "時區已變更。",
        "Token cannot be null or empty": "Token 不可為空值或空白。",
        "token created": "API 授權金鑰已成功建立。",
        "Token has expired": "憑證已過期。",
        "Token's and token's owner companies do not match": "代幣與代幣持有企業不符。",
        "Token was deleted.": "代幣已被刪除。",
        "Too many resources in the request": "請求中包含過多資源",
        "Too Many Requests": "請求過多。",
        "Transfer token created": "傳輸令牌已建立。",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "雙重驗證功能已為使用者啟用。",
        "Two factor authentication successfully disabled.": "雙重驗證已成功停用。",
        "Unable to send SMS. This device does not have a GSM number assigned.": "無法發送簡訊。此裝置未被分配GSM號碼。",
        "Unable to validate Your request.": "無法驗證您的請求。",
        "Unauthenticated.": "未經驗證。",
        "Unauthorized": "未經授權。",
        "User access level is not valid": "使用者存取層級無效",
        "User invitation was revoked": "邀請已成功取消。",
        "User invitation was re-sent": "已重新發送用戶邀請函。",
        "User is already in the system.": "使用者已登錄系統。",
        "User was created.": "使用者已建立。",
        "User was deleted.": "使用者已被刪除。",
        "User was invited.": "用戶邀請已成功發送。",
        "User was updated": "使用者資料已更新。",
        "Users count limit exceeded.": "使用者數量上限已達。",
        "Your password has been changed.": "您的密碼已變更。"
    },
    "General": {
        "0": "使用者",
        "5": "支援",
        "10": "管理員",
        "15": "管理員管理系統",
        "19": "",
        "20": "系統使用者",
        "99": "超級使用者",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "公司建立",
        "Company.Delete": "公司刪除",
        "Company.Merge": "公司合併",
        "Company.Update": "公司動態",
        "Device.Export": "裝置匯出",
        "Device.Read": "裝置讀取",
        "Device.SecretsRead": "",
        "Device.Transfer": "裝置轉移",
        "Device.Unlock": "裝置解鎖",
        "Device.Update": "裝置更新",
        "DeviceGroup.Create": "裝置群組建立",
        "DeviceGroup.Delete": "裝置群組刪除",
        "DeviceGroup.Read": "裝置群組讀取",
        "DeviceGroup.Update": "裝置群組更新",
        "File.Create": "檔案建立",
        "File.Delete": "檔案刪除",
        "File.Download": "檔案下載",
        "File.Read": "檔案讀取",
        "File.TctWebAccess": "TCT web",
        "File.Update": "檔案更新",
        "Role.Create": "角色建立",
        "Role.Delete": "角色刪除",
        "Role.Read": "角色讀取",
        "Role.Update": "角色更新",
        "Task.Create": "任務建立",
        "Task.Read": "任務讀取",
        "Task.Retry": "任務重試",
        "Task.Update": "任務更新",
        "TaskGroup.Read": "任務群組讀取",
        "TctIntegration.Access": "TCT整合",
        "Token.Create": "代幣創建",
        "Token.Delete": "刪除代幣",
        "Token.Read": "讀取代幣",
        "User.Create": "",
        "User.Delete": "刪除使用者",
        "User.Read": "使用者閱讀",
        "User.Update": "使用者更新",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "1-Wire授權清單",
        "1_wire_authorization_list": "1-Wire授權清單",
        "Active": "活躍",
        "adas_firmware": "先進駕駛輔助系統韌體",
        "apx_firmware": "APX韌體",
        "assign can package": "分配CAN套件",
        "assigned package": "指定方案",
        "automatic": "自動化",
        "banner management": "",
        "batches": "任務群組",
        "black_box": "黑盒子",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE韌體",
        "blue_nrg": "BlueNRG 韌體",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "藍牙授權清單",
        "bluetooth_authorization_list": "藍牙授權清單",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "不相容",
                "true": "相容性"
            },
            "web_editor_support": {
                "false": "TCT web不支援",
                "true": "支援TCT web介面"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN 轉接器名稱",
        "can bootstring": "Bootstring",
        "can configuration": "OEM 配置",
        "can_debug_log": "CAN 偵錯記錄",
        "can oem file package": "OEM 檔案套件",
        "can oem file vehicle": "OEM 檔案載體",
        "can package": "OEM 套件",
        "can program number": "CAN程式編號",
        "can revision": "CAN修訂版",
        "can software date": "CAN 軟體資料",
        "can type": "CAN 類型",
        "Cancelled": "已取消",
        "cancel task": "取消任務",
        "can_chip_firmware": "FM CAN晶片韌體",
        "carrier_advance_firmware": "Carrier Advance 韌體",
        "carrier_advance_settings": "Carrier Advance設定",
        "carrier_apx_firmware": "Carrier APX 韌體",
        "carrier_apx_settings": "Carrier APX 設定",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier溫度記錄器檔案",
        "certificate": "證書",
        "click for more details": "點擊查看更多詳情",
        "client ip": "客戶端IP",
        "clone model": "複製裝置模型",
        "collapse menu": "收合選單",
        "companies": "企業",
        "company": "公司",
        "company level": "企業級",
        "company type": "公司類型",
        "company name": "公司名稱",
        "Completed": "已完成",
        "Completed with errors": "已完成但存在錯誤",
        "configuration": "設定",
        "configuration_36": "配置 (FM36)",
        "configuration_64": "配置 (FMB64)",
        "crash_dump": "崩潰轉儲記錄",
        "created at": "建立於",
        "created by": "由",
        "custom": "客製化",
        "custom resource limits": "自訂資源限制",
        "dashboard": "儀表板",
        "delete desktop license": "刪除desktop授權",
        "delete offline license": "刪除離線授權",
        "desktopLicenses": "Desktop授權",
        "device_export_file_csv": "裝置匯出檔案 (.csv)",
        "device_export_file_xlsx": "裝置匯出檔案 (.xlsx)",
        "deviceModels": "模型",
        "deviceModelTaskCompatibilities": "相容性",
        "device_transfer_report": "裝置轉移報告",
        "device group": "群組",
        "DeviceImportFile": "裝置匯入檔案",
        "devices": "裝置",
        "download file": "下載檔案",
        "download offline license": "下載離線授權",
        "dsm_firmware": "DSM 韌體",
        "dtb": "DTB",
        "edit compatibility": "編輯裝置相容性",
        "edit model": "編輯裝置型號",
        "edit company": "編輯公司",
        "edit desktop license": "編輯Desktop版授權",
        "edit device": "編輯裝置",
        "edit file": "編輯檔案",
        "edit group": "編輯群組",
        "edit in tct web": "於 TCT web 編輯",
        "edit in tct web disabled": "TCT web編輯功能僅限企業級Premium方案使用。",
        "edit product code": "編輯產品代碼",
        "edit role": "編輯角色",
        "edit smart group": "編輯智慧群組",
        "edit user": "編輯使用者",
        "Empty": "空",
        "enter here": "請由此進入",
        "exception_info": "異常資訊",
        "Executing": "執行",
        "expand menu": "展開選單",
        "Expired": "已過期",
        "Factory": "",
        "Failed": "失敗",
        "file": "檔案",
        "file data": "檔案資料",
        "files": "檔案",
        "file deleted": "檔案已刪除",
        "firmware": "韌體",
        "firmware_36": "韌體 (FM36)",
        "firmware_64": "韌體 (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "韌體套件",
        "fw_bundle_ble": "套件 - BLE 韌體",
        "fw_bundle_ble_dtb": "套裝方案 - BLE DTB",
        "fw_bundle_can": "套裝方案 - CAN 韌體",
        "fw_bundle_can_dtb": "套裝方案 - CAN DTB",
        "fw_bundle_dtb": "套裝組合 - 主DTB",
        "fw_bundle_mainfw": "套件 - 主韌體",
        "generic": "",
        "global_configuration": "全球配置",
        "global_firmware": "全球韌體",
        "gnssm_download_assistant": "GNSS-M 下載助手",
        "gnssm_firmware": "GNSS-M 韌體",
        "group": "群組",
        "groups": "裝置群組",
        "hardware key": "硬體金鑰",
        "id": "ID",
        "id_collection_file": "身分證明文件",
        "imei restriction": "IMEI限制",
        "Inactive": "非活動狀態",
        "Invalid": "無效",
        "invalid model": "無效模型",
        "invalid model_name": "無效模型",
        "InvitationExpired": "已過期的邀請",
        "InvitationPending": "待邀請",
        "Legacy": "傳統系統",
        "legacy model": "傳統模型",
        "legacy model_platform": "傳統平台",
        "legacy platform": "傳統平台",
        "license has expired": "授權已過期",
        "loading": "載入中",
        "log": "記錄",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "手動",
        "ManualGeofenceList": "",
        "manual geofence list": "手動地理圍欄情境清單",
        "manual_geofence_list": "手動地理圍欄情境清單",
        "meig_modem_firmware": "美格數據機韌體",
        "menu": "選單",
        "modem version": "數據機版本",
        "netprisma_modem_firmware": "NETPRISMA 數據機韌體",
        "nmea_log": "NMEA 日誌",
        "no": "無",
        "no results": "暫未找到任何初始結果",
        "no results description": "當 {{name}} 上傳至 FOTA WEB 後，您即可在此處查看相關數據",
        "not assigned": "未指派",
        "not assigned configuration_file_id": "尚未指派之設定",
        "not assigned current_configuration": "尚未指派之設定",
        "not assigned current_firmware": "尚未指派韌體",
        "not assigned firmware_file_id": "尚未指派韌體",
        "not assigned group_id": "未分配群組",
        "not assigned model": "模型未指派",
        "not assigned spec_id": "Spec ID尚未指派",
        "not assigned task_type": "任務類型未指派",
        "obd_chip_firmware": "FM OBD晶片韌體",
        "obd chip firmware version": "OBD晶片韌體版本",
        "Offline": "離線",
        "offline licenses": "離線授權",
        "Online": "線上",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "或",
        "other": "其他",
        "Pending": "待處理",
        "Pending approval": "等待核准",
        "permission disabled": "已停用",
        "permission enabled": "啟用",
        "productCodes": "產品代碼",
        "psub": "訂閱檔案",
        "quectel_fw": "Quectel 數據機韌體 (quectel_fw)",
        "quectel_modem_firmware": "Quectel 數據機韌體",
        "resend invite": "重新發送邀請",
        "restricted": "受限",
        "retry": "重試",
        "roles": "角色與權限設定",
        "Running": "運行中",
        "RxAutoscan": "接收自動掃描CAN檔案",
        "RxBlackBox": "接收黑盒子",
        "RxBluetoothAuthorizationList": "接收藍牙授權清單",
        "RxCanDebugLog": "接收CAN除錯日誌",
        "RxCarrierExtractions": "下載Carrier extractions",
        "RxCarrierLoggerFiles": "下載Carrier溫度記錄器檔案",
        "RxConfiguration": "接收設定",
        "RxCrashDump": "接收當機轉儲日誌",
        "RxExceptionInfo": "接收異常資訊",
        "RxLog": "接收內部日誌",
        "RxManualGeofenceList": "接收手動地理圍欄情境清單",
        "RxNmeaLog": "接收 NMEA 日誌",
        "RxOneWireAuthorizationList": "接收 1-Wire 授權清單",
        "RxWdLog": "接收看門狗（WD）日誌",
        "select company": "選擇公司",
        "SetBindSim": "將裝置與當前SIM卡綁定",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "停用功能",
        "SetEnableFeature": "啟用功能",
        "SetForceLockSim": "強制鎖定 SIM 卡",
        "SetUnbindSim": "解除與SIM卡綁定的裝置",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "狀態",
        "task details": "任務詳情",
        "task groups": "任務群組",
        "tasks": "任務群組",
        "tasksCompatibility": "任務相容性",
        "task type": "任務類型",
        "Tct": "",
        "time zone": "時區",
        "total": "總計",
        "tutorials": "教學指南",
        "TxAdasFirmware": "上傳 ADAS 韌體",
        "TxAgpsMt3333": "傳輸 AGPSM 檔案",
        "TxAgpsQuectelL89": "傳輸AGPSQ檔案",
        "TxAutoscanCanConfiguration": "上傳自動掃描OEM檔案",
        "TxBleFirmware": "上傳 BLE 固件",
        "TxBlueNrgFirmware": "上傳 BlueNrg 韌體",
        "TxBluetoothAuthorizationList": "上傳藍牙授權清單",
        "TxBundleBle": "上傳 BLE 韌體",
        "TxBundleBleDtb": "上傳 BLE 裝置資料庫 (DTB)",
        "TxBundleCan": "上傳CAN韌體",
        "TxBundleCanDtb": "上傳 CAN DTB",
        "TxBundleDtb": "上傳主DTB",
        "TxBundleFirmware": "上傳主韌體",
        "TxCanAdapterModeChange": "變更外部CAN介面卡模式",
        "TxCanAdapterModeChangeInternal": "變更內部CAN介面卡模式",
        "TxCanAdapterUpdate": "上傳CAN介面卡韌體",
        "TxCanAdapterUpdateInternal": "更新內部CAN介面卡",
        "TxCanChipFirmware": "上傳 FMXY50 CAN 晶片韌體",
        "TxCanConfiguration": "上傳 OEM 檔案",
        "TxCarrierAdvanceFirmware": "更新 Carrier Advance 韌體",
        "TxCarrierAdvanceSettings": "更新Carrier Advance設定",
        "TxCarrierApxFirmware": "更新 Carrier APX 固件",
        "TxCarrierApxSettings": "更新Carrier APX設定",
        "TxConfiguration": "上傳設定",
        "TxDsmFirmware": "上傳 DSM 固件",
        "TxDtb": "上傳 DTB",
        "TxFirmware": "上傳韌體",
        "TxFirmwareBundle": "上傳韌體套件容器",
        "TxFirmwareBundleParts": "上傳韌體套件",
        "TxFotaCertificate": "更新 FOTA 證書",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "上傳 GNSS-M 下載助手",
        "TxGNSSMFirmware": "上傳 GNSS-M 固件",
        "TxManualGeofenceList": "上傳手動地理圍欄情境清單",
        "TxMeigModemDeltaFirmware": "上傳 MeiG Delta 數據機韌體",
        "TxNetprismaModemDeltaFirmware": "上傳 NETPRISMA Delta 數據機韌體",
        "TxObdChipFirmware": "更新OBD晶片",
        "TxObdConfig": "傳輸OBD設定檔",
        "TxOneWireAuthorizationList": "上傳 1-Wire 授權清單",
        "TxPSub": "轉移訂閱檔案",
        "TxQuectelModemDeltaFirmware": "上傳凱捷Delta數據機韌體",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "上傳使用者 TLS 憑證",
        "users": "使用者",
        "Unknown": "未知",
        "unknown": "未知",
        "unknown model_platform": "未知平台",
        "unknown origin": "",
        "unknown platform": "未知平台",
        "unrestricted": "無限制",
        "Verifying": "驗證",
        "vin": "車牌號碼",
        "vip status": "VIP 狀態",
        "wd_log": "WD 日誌",
        "yes": "是"
    },
    "Maintenance": {
        "title": "稍等！系統正在維護中。"
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} 因伺服器錯誤而失敗。",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "您無權取消所有已選取的任務。部分任務涉及不同公司的資源。",
            "Cancel tasks action failed. No resources found.": "未找到符合您選擇的任務。請檢視您的任務選擇並重新嘗試。",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "公司「{{SourceCompanyName}}」（{{SourceCompanyId}}）已併入「{{TargetCompanyName}}」（{{TargetCompanyId}}）。",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "公司合併失敗。由於設定或權限不相容，無法合併公司「{{SourceCompanyId}}」與「{{TargetCompanyId}}」。",
            "Create device group tasks action failed. No resources found.": "無法為智慧群組建立任務。請嘗試重新指派該檔案。",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "已為裝置群組 ID：{{GroupId}} 下的裝置建立 {{CreatedTaskCount}} 項任務。",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "您無權限為所有選取裝置建立任務。部分裝置隸屬於不同公司。",
            "Create tasks action failed. No resources found.": "未找到符合您選擇的裝置。請檢查您的裝置選擇並重新嘗試。",
            "Create tasks action failed. No resources processed.": "處理所選裝置時發生錯誤。請嘗試重新建立任務群組。",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "您無權刪除所有已選取的公司。部分公司不屬於您的直接管理範圍。",
            "Delete companies action failed. No resources found.": "沒有符合您選擇的公司。請檢視您的公司選擇並重新嘗試。",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "您無權刪除所有已選取的檔案。部分檔案與不同公司的資源相關聯。",
            "Delete files action failed. No resources found.": "未找到符合您選擇的檔案。請檢查您的檔案選擇並重新嘗試。",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "您無權刪除所有已選取的裝置群組。部分裝置群組包含來自不同公司的資源。",
            "Delete groups action failed. No resources found.": "未找到符合您選擇的裝置群組。請檢查裝置群組設定後重新嘗試。",
            "Delete product codes action failed. No resources found.": "未找到符合您選擇的產品代碼。請檢查產品代碼選擇並重新嘗試。",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "您無權刪除所有已選取的使用者。部分使用者隸屬於不同公司。",
            "Delete users action failed. No resources found.": "未找到符合您篩選條件的使用者。請檢視使用者篩選條件後重新嘗試。",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} 台裝置已匯出至「{{Filename}}」。",
            "{{DevicesCount}} device(s) imported.": "已匯入 {{DevicesCount}} 台裝置。",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "已處理 {{DevicesProcessedCount}} 台裝置，已建立 {{TasksCreatedCount}} 項任務。",
            "Export devices action failed. No resources found.": "未找到符合您選擇的裝置。請檢查您的裝置選擇並重新嘗試。",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "任務群組 {{BatchId}} 中有 {{FailedTaskCount}} 個任務已返回待處理狀態。",
            "Invalid request scope. Resources must belong to single root.": "請求範圍無效。資源必須屬於單一根節點。",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "已刪除 {{ProcessedCount}} 家企業。",
            "{{ProcessedCount}} device group(s) deleted.": "已刪除 {{ProcessedCount}} 個裝置群組。",
            "{{ProcessedCount}} device attribute(s) updated.": "已更新 {{ProcessedCount}} 個裝置屬性。",
            "{{ProcessedCount}} device model(s) deleted.": "已刪除 {{ProcessedCount}} 部裝置型號。",
            "{{ProcessedCount}} device(s) updated.": "已更新 {{ProcessedCount}} 台裝置。",
            "{{ProcessedCount}} file(s) deleted.": "已刪除 {{ProcessedCount}} 個檔案。",
            "{{ProcessedCount}} product code(s) deleted.": "已刪除 {{ProcessedCount}} 項產品代碼。",
            "{{ProcessedCount}} task(s) canceled.": "已取消 {{ProcessedCount}} 項任務。",
            "{{ProcessedCount}} task(s) updated.": "已更新 {{ProcessedCount}} 項任務。",
            "{{ProcessedCount}} user(s) deleted.": "已刪除 {{ProcessedCount}} 位使用者。",
            "Retry tasks action failed. No resources found.": "未找到符合您選擇的任務。請檢視您的任務選擇並重新嘗試。",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "您無權限移轉所有已選取的裝置。部分裝置隸屬於不同公司。",
            "Transfer devices action failed. No resources found.": "未找到符合您選擇的裝置。請檢查您的裝置選擇並重新嘗試。",
            "Transfer devices action failed. No resources processed.": "處理所選裝置時發生錯誤。請嘗試重新傳輸裝置。",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "已轉移 {{TransferredDevicesCount}} 台裝置，共需轉移 {{TotalDevicesToTransfer}} 台裝置。",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "您無權限更新所有已選取的裝置。部分裝置隸屬於不同公司。",
            "Update devices action failed. No resources found.": "未找到符合您選擇的裝置。請檢查您的裝置選擇並重新嘗試。",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "您無權限更新所有已選取裝置的屬性。部分裝置隸屬於不同公司。",
            "Update devices attributes action failed. No resources found.": "未找到符合您選擇的裝置。請檢查您的裝置選擇並重新嘗試。",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "您無權限更新所有已選任務。部分任務涉及不同公司的資源。",
            "Update tasks action failed. No resources found.": "未找到符合您選擇的任務。請檢視您的任務選擇並重新嘗試。",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "無通知功能",
        "notifications": "通知",
        "notifications will be listed": "所有新通知將在此處列出",
        "remove notification": "移除通知",
        "see previous notifications": "查看先前通知",
        "timestamps": {
            "days ago": "{{days}}天前",
            "hours ago": "{{hours}}小時前",
            "minutes ago": "{{minutes}} 分鐘前",
            "moments ago": "就在方才"
        },
        "title": {
            "BackgroundActionFailed": "操作失敗",
            "CompaniesSuccessfullyDeleted": "企業成功刪除",
            "CompanyBulkDeleteFailed": "刪除公司時發生錯誤",
            "CompanyLevelChanged": "公司層級變更",
            "CompanyLevelDowngradeReminder": "即將實施的企業級降級方案",
            "CompanyMergeFailed": "合併公司時發生錯誤",
            "CompanySuccessfullyMerged": "企業成功合併",
            "DeviceAttributesSuccessfullyUpdated": "裝置屬性已成功更新",
            "DeviceBulkAttributeUpdateFailed": "更新裝置屬性時發生錯誤",
            "DeviceBulkUpdateFailed": "更新裝置時發生錯誤",
            "DeviceExportFailed": "匯出裝置時發生錯誤",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "裝置群組已成功刪除",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "建立智慧群組任務時發生錯誤",
            "DeviceGroupTasksSuccessfullyCreated": "智慧群組任務已成功建立",
            "DeviceModelBulkDeleteFailed": "刪除裝置型號時發生錯誤",
            "DeviceModelsSuccessfullyDeleted": "裝置型號已成功刪除",
            "DevicesSuccessfullyTransferred": "裝置已成功轉移",
            "DevicesSuccessfullyUpdated": "裝置已成功更新",
            "DeviceTransferFailed": "在轉移裝置時發生錯誤",
            "ExportFailed": "資源匯出失敗",
            "ExportSucceeded": "裝置已成功匯出",
            "FailedTasksRetryFailed": "在重試任務時發生錯誤",
            "FailedTasksSuccessfullyRetried": "任務重試成功",
            "FileBulkDeleteFailed": "刪除檔案時發生錯誤",
            "FilesSuccessfullyDeleted": "檔案已成功刪除",
            "GroupBulkDeleteFailed": "刪除裝置群組時發生錯誤",
            "ImportFailed": "資源匯入失敗",
            "ImportSucceeded": "裝置已成功匯入",
            "ProductCodeBulkDeleteFailed": "刪除產品代碼時發生錯誤",
            "ProductCodesSuccessfullyDeleted": "產品代碼已成功刪除",
            "ResourceUpdateFailed": "資源更新失敗",
            "ResourceUpdateSucceeded": "資源更新成功",
            "RoleBulkDeleteFailed": "刪除角色時發生錯誤",
            "RolesSuccessfullyDeleted": "角色已成功刪除",
            "TaskBulkCancelFailed": "取消任務時發生錯誤",
            "TaskBulkCreateFailed": "建立任務群組時發生錯誤",
            "TaskBulkUpdateFailed": "更新任務時發生錯誤",
            "TaskGroupSuccessfullyCreated": "任務群組已成功建立",
            "TasksPropagationFailed": "任務傳播作業失敗",
            "TasksPropagationSucceeded": "任務傳播作業成功",
            "TasksPropagationWarning": "任務傳播作業已結束，並伴隨警告訊息",
            "TasksSuccessfullyCanceled": "任務已成功取消",
            "TasksSuccessfullyUpdated": "任務已成功更新",
            "UserBulkDeleteFailed": "刪除使用者時發生錯誤",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "使用者已成功刪除"
        }
    },
    "Permission actions": {
        "Access": "TCT整合",
        "Create": "建立",
        "Delete": "刪除",
        "Download": "下載",
        "Export": "匯出",
        "Merge": "合併",
        "Read": "閱讀",
        "Retry": "重試",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "傳輸",
        "Unlock": "解鎖",
        "Update": "更新"
    },
    "Permission groups": {
        "company": "企業",
        "device": "裝置",
        "device group": "裝置群組",
        "file": "檔案",
        "role": "角色",
        "task": "任務",
        "task group": "任務群組",
        "token": "代幣",
        "user": "使用者"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "此選項對基本公司級別的用戶已停用。",
                "token list": "基本公司級別的用戶將停用 API 整合令牌功能。"
            },
            "custom_role_support": {
                "create role": "此功能僅限擁有企業級高級帳戶的用戶使用。",
                "edit role": "此功能僅限擁有企業高級帳戶的用戶使用。先前建立的自訂角色可被刪除。",
                "edit user": "此功能僅限擁有企業級高級帳戶的用戶使用。先前指派的自訂角色可被移除。"
            },
            "task_schedule_support": {
                "table head": "此功能僅限標準版與進階版企業級用戶使用。先前設定排程的任務仍將照常執行。"
            }
        },
        "general message": "此功能僅限標準版與進階版企業級別的用戶使用。",
        "resource_limit_settings": {
            "tasks_per_group": "您無法同時為超過 {{limitCount}} 台裝置建立任務。"
        }
    },
    "Search": {
        "code": "程式碼",
        "description": "描述",
        "email": "電子郵件",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "國際移動設備識別碼",
        "model": "模型",
        "name": "名稱",
        "product code": "產品代碼",
        "role name": "角色名稱",
        "serial": "序號",
        "search by": "按以下條件搜尋：",
        "search company name": "搜尋公司名稱"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "您即將停用雙重驗證功能。此舉可能導致您的 FOTA WEB 帳戶安全性降低。確定要繼續嗎？",
                    "title": "您確定嗎？"
                },
                "send email code": {
                    "enter code": "基於安全考量，請輸入驗證碼以確認電子郵件地址。"
                },
                "send otp code": {
                    "description": "系統已向您的驗證應用程式發送六位數驗證碼。基於安全考量，請於下方欄位輸入生成的驗證碼。",
                    "no access": {
                        "authenticator": "若您無法再存取與此帳戶連結的驗證器應用程式，則需變更密碼以停用雙重驗證功能。",
                        "email": "若您已無法存取此帳戶綁定的電子郵件，需先變更密碼以停用多因素驗證功能。"
                    }
                },
                "title": "停用雙重驗證"
            },
            "get email code": {
                "description": "請於下一畫面使用該驗證碼確認您的帳戶。",
                "description modal": "請使用該驗證碼確認您的帳戶。",
                "title": "按下「發送驗證碼」後，系統將向 <1>{{email}}</1> 發送一組唯一驗證碼。"
            },
            "get secret code": {
                "description": "您需要使用驗證器行動應用程式完成此流程，例如以下任一應用程式："
            },
            "select authentication type": {
                "authentication app description": "透過 Microsoft Authenticator 或 Google Authenticator 等應用程式取得唯一驗證碼。",
                "description": "為確保您的帳戶與客戶資料安全，請採用以下任一方式設定雙重驗證：",
                "description modal": "請選擇您偏好的驗證方式。",
                "email": "電子郵件",
                "email description": "每當您嘗試登入時，我們將向您的電子郵件發送一次性驗證碼。",
                "recommended": "推薦",
                "title": "所有FOTA WEB用戶均須強制啟用雙重驗證（2FA）。",
                "title modal": "選擇驗證方式"
            },
            "send email code": {
                "description": "請在下方欄位輸入驗證碼，並按下「驗證」按鈕繼續。",
                "enter code": "請輸入驗證碼以確認電子郵件地址。",
                "title": "已向 <1>{{email}}</1> 發送一組獨特代碼。",
                "verification code": "驗證碼"
            },
            "send otp code": {
                "click to scan code": "點擊此處以掃描 QR 碼代替",
                "click to type code": "請點擊此處手動輸入代碼",
                "incorrect code": "錯誤程式碼",
                "scan QR code": "掃描 QR 碼至您的應用程式",
                "six digit code": "由您的應用程式生成的六位數驗證碼",
                "title": "您需要使用驗證器行動應用程式完成此流程，例如：<1>Microsoft Authenticator</1> 或 <2>Google Authenticator</2>。",
                "type text code": "將文字代碼輸入您的應用程式"
            },
            "settings": {
                "description": "雙重驗證是額外的安全防護層，透過您「知曉的資訊」（密碼）與「持有的物品」（手機、安全金鑰、電子郵件）雙重驗證您的身分。",
                "disabled": "已停用",
                "enabled": "啟用",
                "title": "雙重驗證"
            },
            "success message": {
                "alert": "雙重驗證已成功啟用。",
                "description": "每次您使用電子郵件和密碼登入時，我們都會要求您輸入驗證碼。",
                "title": "您已成功啟用雙重驗證功能。",
                "title modal": "已啟用雙因素驗證！"
            },
            "title": {
                "authentication app": "驗證應用程式",
                "authentication email": "驗證電子郵件",
                "is enabled": "啟用雙重驗證功能。",
                "protect your account": "保護您的 FOTA WEB 帳戶"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "變更密碼",
            "enter current password": "輸入當前密碼",
            "enter new password": "輸入新密碼",
            "hide password": "隱藏密碼",
            "repeat new password": "重複輸入新密碼",
            "rules": {
                "lowercase letter": "至少包含一個小寫字母（a-z）",
                "minimum characters": "至少 12 個字元",
                "new and current passwords must not match": "新密碼與現行密碼不得相同",
                "new passwords must match": "新密碼必須相符",
                "number": "至少一個數字",
                "passwords must match": "密碼必須完全匹配",
                "special symbol": "至少包含一個特殊符號 (!@#$%^&*()-_=+)",
                "uppercase letter": "至少包含一個大寫字母（A-Z）"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "顯示密碼"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "表格統計",
        "statistics message": "表格篩選條件將影響下方顯示的統計數據",
        "activity": "活動",
        "model": "模型",
        "firmware": "韌體",
        "configuration": "設定",
        "statistics": "統計數據"
    },
    "Table": {
        "1_wire_authorization": "1-Wire授權",
        "access group": "",
        "access groups": "",
        "access level": "存取層級",
        "accessories": "配件",
        "action": "操作",
        "action date": "行動日期",
        "assigned package": "指定方案",
        "attempt count": "嘗試次數",
        "attribute": "屬性",
        "attributes": "屬性",
        "auto sync": "",
        "batch id": "批次識別碼",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE韌體",
        "bluetooth_authorization": "藍牙授權",
        "bootloader": "開機載入器",
        "can_adapter": "CAN 匯流排轉接器",
        "can adapter name": "CAN 轉接器名稱",
        "can bootstring": "Bootstring",
        "can oem file package": "OEM 檔案套件",
        "can oem file vehicle": "OEM 檔案載體",
        "can package": "CAN 套件",
        "can program number": "CAN程式編號",
        "can software date": "CAN 軟體資料",
        "can type": "CAN 類型",
        "carrier module id": "模組識別碼",
        "carrier revision": "修訂版",
        "carrier serial id": "序列識別碼",
        "carrier settings filename": "設定檔名稱",
        "carrier unit status": "狀態",
        "carrier unit type": "單元類型",
        "changed at": "變更於",
        "change origin": "",
        "changes": "變更",
        "checkbox disabled": {
            "role": "靜態角色無法編輯或刪除。"
        },
        "child company": "<0>隸屬於</0><1>{{parentCompany}}</1>",
        "child companies": "子公司",
        "code": "程式碼",
        "company": "公司",
        "company hierarchy": "公司組織架構",
        "company name": "公司名稱",
        "compatibility": "相容性",
        "configuration": "設定",
        "configuration details": "配置細節",
        "configuration type": "",
        "created at": "建立於",
        "created by": "由",
        "date": "日期",
        "description": "描述",
        "device details": "裝置詳細資訊",
        "device company": "裝置公司",
        "device description": "裝置描述",
        "device group": "裝置群組",
        "device imei": "裝置 IMEI",
        "device model": "裝置型號",
        "device seen at": "裝置顯示於",
        "device serial": "裝置序號",
        "devices": "裝置",
        "devices count": "裝置數量",
        "Done": "完成",
        "download at": "",
        "download file": "下載檔案",
        "dtb": "DTB",
        "edit file": "編輯檔案",
        "edit group banner": "若將裝置加入已定義韌體和/或設定的群組，所有同類型先前待處理任務將被取消。",
        "email": "電子郵件",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "任務群組建立後，您將可在此處查看清單",
                    "changes": "一旦進行變更，您將可在此處查看清單",
                    "companies": "企業成立後，您即可在此處查看清單",
                    "configurationChanges": "",
                    "desktopLicenses": "一旦建立desktop授權，您即可在此處查看清單",
                    "devices": "裝置一經上傳至FOTA WEB，您即可在此處查看清單",
                    "files": "檔案一經上傳，您即可在此處查看清單",
                    "groups": "群組建立後，您即可在此處查看清單",
                    "offlineLicenses": "離線授權一經建立，您即可在此處查看清單",
                    "permissions": "一旦使用者權限被指派，您即可在此處查看清單",
                    "productCodes": "產品代碼一經建立，您即可在此處查看清單",
                    "roles": "角色建立後，您即可在此處查看清單",
                    "tasks": "任務一經建立，您即可在此處查看任務清單",
                    "users": "新增使用者後，您將可在此處查看使用者清單"
                },
                "title": {
                    "batches": "任務群組表格為空",
                    "changes": "變更記錄表為空",
                    "companies": "公司資料表為空",
                    "configurationChanges": "",
                    "desktopLicenses": "Desktop授權表格為空",
                    "devices": "裝置表格為空",
                    "files": "檔案表格為空",
                    "groups": "群組表格為空",
                    "offlineLicenses": "離線授權表為空",
                    "permissions": "權限表為空",
                    "productCodes": "產品代碼表為空",
                    "roles": "角色表為空",
                    "tasks": "任務表為空",
                    "users": "使用者資料表為空"
                }
            },
            "no permission": {
                "description": "請聯繫您的管理員以申請存取權限。",
                "title": "您沒有權限查看此內容"
            },
            "no results found": {
                "description": "請嘗試其他關鍵字或篩選條件以取得結果",
                "title": "未找到任何結果"
            },
            "button": {
                "add": {
                    "companies": "建立公司",
                    "devices": "新增裝置",
                    "files": "上傳檔案",
                    "groups": "建立群組",
                    "productCodes": "新增產品代碼",
                    "tasks": "建立任務",
                    "users": "邀請使用者"
                },
                "reset view": "重設檢視"
            }
        },
        "exausted autoscan limit": "自動掃描次數已達上限，直至",
        "exausted vin parsing limit": "車輛識別碼解析次數已達上限",
        "expiration": "到期日",
        "expiration date": "到期日期",
        "expires at": "到期時間：",
        "expiry date": "到期日期",
        "field": "現場",
        "file": "檔案",
        "file id": "檔案識別碼",
        "files": "檔案",
        "file type": "檔案類型",
        "filter by": "篩選條件：",
        "firmware": "韌體",
        "general": "通用",
        "general data": "一般資料",
        "gnss version": "GNSS 版本",
        "group": "群組",
        "groups": "裝置群組",
        "group vip status": "",
        "gsm number": "GSM號碼",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "<1>FMx平台</1> - 支援FMx系列（FMB、FMU、FMC、FMM）、FMT、FMP、TAT、MSP、TFT、TST、GH（GH5200）及TMT型號。",
                "ft platform": "<1>FT平台</1> - 包含FTx與ATx型號。",
                "legacy platform": "<1>舊版平台</1> - FM（不含FM4001與FM3010型號）、FMA及GH（GH4000）系列機型。",
                "title": "遠程資訊裝置的平臺生成"
            },
            "visibility": "<2>標記為<1>內部</1>的變更對客戶不可見。</2><2>由於裝置變更可能包含可見與隱藏資料，<1>請勿在外部通訊中分享螢幕截圖或詳細資訊</1>。</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "國際移動設備識別碼",
        "imsi": "IMSI",
        "info": "資訊",
        "interface": "介面",
        "invited by": "應邀",
        "items": "項目",
        "last checked at": "最後檢查於",
        "last sign in": "最後登入時間",
        "last status update": "最後狀態更新",
        "last used at": "最後使用於",
        "license disabled": "已停用",
        "license enabled": "啟用",
        "license key": "授權金鑰",
        "license name": "",
        "links": "連結",
        "manual_geofence_scenarios": "手動地理圍欄情境",
        "message": "訊息",
        "model": "模型",
        "model task type support": {
            "false": "不支援",
            "true": "支援"
        },
        "modem version": "數據機版本",
        "name": "名稱",
        "new value": "嶄新價值",
        "next task": "下一個任務",
        "no changes": "無需變更。",
        "no company name": "無公司名稱",
        "no details": "無詳細資訊",
        "no file": "無檔案",
        "no imei available": "無可用 IMEI 號碼",
        "no model": "無模型",
        "no parent company": "該公司沒有母公司。",
        "no tasks": "該裝置無任務。",
        "number": "數量",
        "obd": "OBD",
        "obd chip firmware version": "OBD晶片韌體版本",
        "of": "的",
        "offline licenses tab disabled": "已停用的Desktop授權不提供離線授權。",
        "original value": "原始價值",
        "other information": "其他資訊",
        "page of": "頁面",
        "parent company": "母公司",
        "permission count": "權限計數",
        "platform": "平台",
        "Price": "價格",
        "product code": "產品代碼",
        "program number": "程式編號",
        "property": "物業",
        "queue": "佇列",
        "receiving company": "接收公司",
        "revision": "修訂版",
        "role": "角色",
        "role name": "角色名稱",
        "rows per page": "每頁顯示行數",
        "running": "運行中",
        "schedule": "排程",
        "seen at": "見於",
        "select row": "選取一行以查看詳細資訊",
        "send sms": "發送簡訊",
        "serial": "序號",
        "show details": {
            "desktopLicenses": "顯示Desktop版授權詳細資訊",
            "devices": "顯示裝置詳細資訊",
            "batches": "顯示任務群組詳細資訊",
            "tasks": "顯示任務詳情",
            "companies": "顯示公司詳情"
        },
        "sim": "SIM",
        "size": "尺寸",
        "software date": "軟體日期",
        "source company": "源公司",
        "spec_id": "Spec ID",
        "status": "狀態",
        "status id": "狀態識別碼",
        "status name": "狀態名稱",
        "supported task types": "支援的任務類型",
        "synced at": "",
        "table columns": "表格欄位",
        "target company": "目標公司",
        "task id": "任務ID",
        "task queue": "任務佇列",
        "tasks": "任務",
        "task type": "任務類型",
        "tct web support": "TCT web 支援",
        "total": "總計",
        "type": "類型",
        "updated at": "更新於",
        "updated by": "更新於",
        "unknown": "未知",
        "user cannot be deleted": "使用者帳戶不得刪除。",
        "user cannot be edited": "使用者資料不可編輯。",
        "user cannot delete himself": "使用者無法刪除自身個人檔案。",
        "user date statuses": {
            "expired": "已過期",
            "expires": "到期",
            "never expires": "永不過期",
            "sent": "已發送"
        },
        "user email": "使用者電子郵件",
        "user invitation cannot be cancelled": "用戶邀請無法取消。",
        "user invitation cannot be resent": "使用者邀請函無法重新發送。",
        "user statuses": {
            "Active": "活躍",
            "Inactive": "非活動狀態",
            "InvitationExpired": "已過期的邀請",
            "InvitationPending": "待邀請"
        },
        "users": "使用者",
        "value from": "價值來源",
        "value to": "價值在於",
        "view all roles": "查看全部 ({{count}})",
        "vin": "車牌號碼",
        "vip status": "VIP 狀態",
        "visibility": "可視性"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "權限資訊",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "配件介面名稱。",
                    "type": "連接配件類型。"
                },
                "can": {
                    "assigned package": "分配至該裝置的OEM套件。",
                    "can oem file package": "上次連線時回報的OEM套件。",
                    "can oem file vehicle": "上回連線時回報的OEM車輛配置。",
                    "dtb": "",
                    "firmware": "CAN 韌體版本。"
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "最新接收到的CAN轉接器啟動字串，包含當前數據及轉接器的程式編號。",
                    "program number": "CAN 轉接器的程式編號。",
                    "revision": "",
                    "software date": "CAN介面卡的軟體日期。",
                    "type": "CAN介面卡的類型。"
                },
                "configuration details": {
                    "1_wire_authorization": "最後傳送的1-Wire授權清單檔案名稱。",
                    "bluetooth_authorization": "最後傳送的藍牙授權清單檔案名稱。",
                    "main configuration": "最後傳送的主配置檔名稱。",
                    "manual_geofence_scenarios": "最後傳送的手動地理圍欄清單檔案名稱。"
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "上次連線時回報的 BLE 韌體版本。",
                    "bluetooth password": "",
                    "bootloader": "裝置開機載入程式於上次連線時回報的版本。",
                    "company": "擁有此裝置的公司。",
                    "configuration": "最後傳送的設定檔名稱。",
                    "description": "裝置描述（使用者自定義）。",
                    "dtb": "裝置樹 blob 在上次連線時回報的版本。",
                    "firmware": "裝置韌體版本——於上次連線時回報的版本。",
                    "gnss version": "上次連線時回報的GNSS版本。",
                    "group": "此裝置所隸屬的裝置群組。",
                    "product code": "裝置產品代碼。",
                    "serial": "裝置序號。"
                },
                "obd": {
                    "obd chip firmware version": "上次連線時回報的OBD晶片韌體版本。",
                    "vin": "一組獨特的17位元碼，用於識別特定機動車輛。"
                },
                "sim": {
                    "gsm number": "與裝置關聯的公共電話號碼。",
                    "iccid": "用於識別SIM卡的唯一序列號。",
                    "imsi": "行動網路用戶的唯一識別碼。"
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "使用者建立的日期與時間。",
                    "id": "用戶的唯一識別碼。",
                    "invited by": "創建邀請的用戶電子郵件地址。",
                    "role": "指分配給用戶的角色。",
                    "updated at": "最後一次使用者更新的日期與時間。"
                }
            }
        },
        "user details": "使用者詳細資訊"
    },
    "Task groups": {
        "all": "所有",
        "bulk type": {
            "CompanyBulkDelete": "刪除公司",
            "DeviceBulkCreate": "新增裝置",
            "DeviceBulkDelete": "刪除裝置",
            "DeviceBulkUpdate": "更新裝置",
            "FileBulkDelete": "刪除檔案",
            "GroupBulkDelete": "刪除群組",
            "TaskBulkCreate": "建立任務",
            "TaskBulkUpdate": "取消任務",
            "UserBulkDelete": "刪除使用者"
        },
        "pending approval": "待核准",
        "already approved": "已獲核准",
        "no approval required": "無需審核",
        "total objects": "總物件數",
        "total tasks": "總任務數"
    },
    "Task status": {
        "0": "待處理",
        "1": "運行中",
        "2": "已完成",
        "3": "已完成但存在錯誤",
        "4": "已取消",
        "5": "失敗",
        "6": "已過期",
        "7": "等待核准",
        "8": "驗證",
        "task count": {
            "0": "待辦事項",
            "1": "執行任務",
            "3": "已完成帶有錯誤的任務",
            "5": "失敗任務"
        },
        "verified tooltip title": "任務已成功完成並經裝置驗證。"
    },
    "Tasks": {
        "0": "任務已加入佇列，目前處於待處理狀態。",
        "1": "任務目前正在執行中。",
        "2": "任務已成功完成。",
        "3": "任務已完成，但發生若干錯誤。",
        "4": "任務已取消。",
        "5": "任務執行失敗。",
        "6": "任務未能在指定時間內完成。"
    },
    "Tct": {
        "edit configuration": "編輯設定",
        "no editable configurations": "無可編輯的設定檔會被上傳",
        "open tct": "開啟 TCT web 版",
        "open tct description": "您可選擇在TCT web版建立新設定檔，或透過FOTA WEB編輯現有設定檔。",
        "select configuration file": "在 TCT web 選擇您要編輯的設定檔。",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web版僅限企業級Premium方案使用。"
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
